import $ from "jquery"
import _ from "underscore"
import PDFImageCache from "./PDFImageCache"
import {cutLongText} from "../util/StringUtils"
import {PaperSize, PaperOrientation} from "./constants"

export default class BasePDFDefinitionBuilder {
    constructor() {
        this.dd = null // pdf doc definition
        this.params = null
        this.styles = null
    }

    init(paperOrientation, paperSize) {
        this.styles = {};
        this.styles = $.extend(true, this.styles, baseStyles);
        this.styles = $.extend(true, this.styles, this.getAdditionalStyles());

        var parameters = {};
        parameters = $.extend(true, parameters, baseParameters);
        parameters = $.extend(true, parameters, this.getAdditionalParameters());

        this.params = this.compactParameters(parameters, paperOrientation, paperSize);

        return this;
    }

    getAdditionalStyles() {
        return {};
    }

    getAdditionalParameters() {
        return {};
    }

    getAdditionalTableLayouts() {
        return {};
    }

    getTableLayouts() {
        var layouts = {};
        layouts = $.extend(true, layouts, baseTabelLayouts);
        layouts = $.extend(true, layouts, this.getAdditionalTableLayouts());
        return layouts;
    }

    /**
     * Get definition builder parameter from current parameters map
     * @param name parameter name
     * @returns {*} parameter value
     */
    p(name) {
        return this.params[name]
    }

    /**
     * Create flatten map of parameters depend on current page parameters
     * @param parameters builder parameters
     * @param paperOrientation current orientation
     * @param paperSize current paper size
     * @returns {*} flatten map of parameters
     */
    compactParameters(parameters, paperOrientation, paperSize) {
        var paperOrientationKey = paperOrientation === PaperOrientation.LANDSCAPE ? "Landscape" : "Portrait";
        var paperSizeKey = paperSize === PaperSize.A4 ? "A4" : "Letter";

        var params = parameters[paperOrientationKey][paperSizeKey];
        var commonParams = _.omit(parameters, "Landscape", "Portrait");
        var orientationCommonParams = _.omit(parameters[paperOrientationKey], "A4", "Letter");

        _.extend(params, commonParams, orientationCommonParams);

        return params;
    }

    initDocDefinitionObject(headerOnEachPage) {
        this.dd = {};

        this.dd.pageSize = this.p("pageSize");
        this.dd.pageOrientation = this.p("pageOrientation");

        var margins = [];
        _.extend(margins, this.p("pageMargins"));
        if (headerOnEachPage) {
            margins[1] += this.p("headerHeight") + this.p("headerBottomMargin");
        }
        this.dd.pageMargins = margins;
        this.dd.styles = this.styles;

        this.dd.content = [];
    }

    /**
     * Append element to content list in doc definition
     * @param element - dd element fo add
     */
    appendContentElement(element) {
        this.dd.content.push(element);
    }

    /**
     * Add to doc definition page breaker
     */
    addPageBreaker() {
        this.appendContentElement(
            {
                pageBreak: 'after',
                text: ''
            });
    }

    createFilterView(filterTexts) {
        var filterViewParameters = this.p("filterViewParameters");
        var margins = filterViewParameters.margins;
        var marginsImage = filterViewParameters.imageMargins;
        var firstRowMargins = filterViewParameters.firstRowMargins;
        var secondRowMargins = filterViewParameters.secondRowMargins;

        var filterTextMaxLen = this.p("filterViewTextLen");
        var withSecondRow = !_.isUndefined(filterTexts.secondRow);

        var body = [
            [
                {
                    marginLeft: marginsImage.left,
                    marginTop: marginsImage.top,
                    rowSpan: withSecondRow ? 2 : 1,
                    width: filterViewParameters.imageWidth,
                    image: PDFImageCache.getImage("filterIcon")["image"]
                },
                {
                    marginTop: firstRowMargins.top,
                    marginBottom: withSecondRow ? firstRowMargins.bottom : secondRowMargins.bottom,
                    noWrap: true,
                    text: cutLongText(filterTexts.firstRow, filterTextMaxLen)
                }
            ]
        ];

        if (withSecondRow) {
            body.push([
                '',
                {
                    marginBottom: secondRowMargins.bottom,
                    noWrap: true,
                    text: cutLongText(filterTexts.secondRow, filterTextMaxLen)
                }
            ]);
        }

        return {
            style: 'filterView',
            layout: 'thinBordersNoPaddingsForFilterView',
            marginTop: margins.top,
            fontSize: filterViewParameters.fontSize,

            table: {
                widths: filterViewParameters.widths,
                body: body
            }
        };
    }

    createInformationSection(showLogo, logo, texts) {
        var logoElement;
        var infoParams;
        if (showLogo) {
            infoParams = this.p("pdfInfoParameters").withLogo;
            var dimensions = this.calculatePDFLogoDimensions(logo);
            logoElement = {
                rowSpan: 2,
                width: dimensions.w,
                height: dimensions.h,
                marginTop: dimensions.mT,
                marginLeft: dimensions.mL,
                image: logo.image
            }
        }
        else {
            logoElement = '';
            infoParams = this.p("pdfInfoParameters").withoutLogo;
        }
        var columnWidths = infoParams.widths;
        var body = [
            [
                logoElement,
                [
                    {style: 'titleLabel', text: texts.title},
                    {style: 'dateRangeLabel', text: texts.dateRange}
                ]
            ],
            ['', {text: '', marginTop: 5}]
        ];

        return {
            widths: columnWidths,
            body: body
        };
    }

    createHeaderLandscape(information, filterView) {
        return {
            marginBottom: this.p("headerBottomMargin"),
            columns: [
                {
                    width: '67%',
                    layout: 'noBordersNoPadding',

                    table: information
                },
                filterView
            ]
        };
    }

    createHeaderPortrait(information) {
        return {
            layout: 'noBordersNoPadding',

            table: information
        };
    }

    _createHeader(showLogo, data, applier) {
        var filterTexts = data["filterTexts"];
        var informationTexts = data["informationTexts"];
        var logo = data["logo"];

        var filterView = this.createFilterView(filterTexts);

        var infoElement = this.createInformationSection(showLogo, logo, informationTexts);
        applier(infoElement, filterView);
    }

    addPortraitHeader(showOnEachPage, showLogo, data) {
        var s = this;
        var headerApplier;
        if (showOnEachPage) {
            headerApplier = function(pdfInfo, filterView) {
                s.dd.header = function() {
                    var stack = [];
                    stack.push(s.createHeaderPortrait(pdfInfo));
                    stack.push(filterView);
                    var margins = s.p("headerMargins")(s.p("pageMargins"));
                    return function() {
                        var st = [];
                        for (var i = 0; i < stack.length; i++) {
                            st[i] = $.extend(true, {}, stack[i]); // deep copy
                        }
                        return {
                            margin: margins,
                            stack: st
                        };
                    }
                }();
            }
        }
        else {
            headerApplier = function(pdfInfo, filterView) {
                s.appendContentElement(s.createHeaderPortrait(pdfInfo));
                s.appendContentElement(filterView);
                s.appendContentElement({
                    marginBottom: s.p("headerBottomMargin"),
                    text: ""
                })
            };
        }

        this._createHeader(showLogo, data, headerApplier);
    }

    addLandscapeHeader(showOnEachPage, showLogo, data) {
        var s = this;
        var headerApplier;
        if (showOnEachPage) {
            headerApplier = function(pdfInfo, filterView) {
                s.dd.header = function() {
                    var stack = [];
                    stack.push(s.createHeaderLandscape(pdfInfo, filterView));
                    var margins = s.p("headerMargins")(s.p("pageMargins"));
                    return function() {
                        var st = [];
                        for (var i = 0; i < stack.length; i++) {
                            st[i] = $.extend(true, {}, stack[i]); // deep copy
                        }
                        return {
                            margin: margins,
                            stack: st
                        };
                    }
                }();
            }
        }
        else {
            headerApplier = function(pdfInfo, filterView) {
                s.appendContentElement(s.createHeaderLandscape(pdfInfo, filterView));
            };
        }
        this._createHeader(showLogo, data, headerApplier);
    }

    /**
     * method calculate logo image dimensions for fit it to placeholder sizes and save ration
     * @param logoPicture logo picture (logo + sizes in pixels)
     * @returns {{w: number, h: number, mL: number, mT: number}}
     * @private
     */
    calculatePDFLogoDimensions(logoPicture) {

        var maxW = this.p("logoPlaceholderSizes").width;
        var maxH = this.p("logoPlaceholderSizes").height;

        var widthInPix = logoPicture.width;
        var heightInPix = logoPicture.height;

        var ratioForPlace = maxW / maxH;
        var rationForPixSizes = widthInPix / heightInPix;

        var coeff = 0; // coeff for calculate pdf logo dimensions
        // if ration for placeholder(w/h) less than for image, then need to adjust max height of image or width otherwise
        if (ratioForPlace > rationForPixSizes) {
            coeff = heightInPix / maxH;
        }
        else {
            coeff = widthInPix / maxW;
        }
        var wInPDF = widthInPix / coeff;
        var hInPDF = heightInPix / coeff;
        return {
            w: wInPDF,
            h: hInPDF,
            mL: (maxW - wInPDF) / 2,
            mT: 0
        }
    }

    getDocDefinitionObject() {
        return this.dd;
    }

    addIconedNote(text) {
        var noteParameters = this.p("noteParameters");

        var body = [
            [
                {
                    marginLeft: 0,
                    width: 9,
                    image: PDFImageCache.getImage("noteIcon")["image"]
                },
                {
                    marginLeft: noteParameters.marginLeft,
                    fontSize: noteParameters.fontSize,
                    text: text
                }
            ]
        ];

        this.appendContentElement({
            style: 'noteText',
            layout: 'noBordersNoPadding',
            marginTop: 5,
            table: {
                widths: noteParameters.widths,
                body: body
            }
        });
    }

    addNotes(text, asterisk, withMargin) {
        var noteParameters = this.p("noteParameters");
        var body = [
            [
                {
                    marginLeft: 0,
                    fontSize: noteParameters.asteriskSize,
                    color: noteParameters.color,
                    text: asterisk
                },
                {
                    marginLeft: noteParameters.marginLeft,
                    fontSize: noteParameters.fontSize,
                    text: text
                }
            ]
        ];

        this.appendContentElement({
            style: 'noteWithAsterisk',
            layout: 'noBordersNoPadding',
            marginTop: withMargin ? 20 : 5,
            table: {
                widths: noteParameters.widths,
                body: body
            }
        });
    }
}

const baseStyles = {

    headerSeparator: {
        marginTop: 6,
        marginBottom: 8
    },
    titleLabel: {
        marginTop: 5,
        fontSize: 12,
        bold: true
    },

    dateRangeLabel: {
        marginTop: 5,
        fontSize: 12
    },

    filterView: {
        fillColor: '#EFEFEF',
        color: '#373737'
    },
    dataTable: {
        fontSize: 7,
        color: '#111111'
    },

    dataTableSmall: {
        fontSize: 5.4,
        color: '#111111'
    },
    secondDataRow: {
        fillColor: '#EFEFEF'
    },
    dataName: {
        alignment: 'left',
        margin: [10, 2, 0, 2]
    },
    dataNameSmall: {
        alignment: 'left',
        margin: [10, 0, 0, 0]
    },
    dataValue: {
        alignment: 'right',
        margin: [5, 2, 5, 2]
    },
    dataValueSmall: {
        alignment: 'right',
        margin: [5, 0, 5, 0]
    },
    dataValueWithPercents: {
        alignment: 'right',
        margin: [2, 2, 0, 2]
    },
    dataValueWithPercentsSmall: {
        alignment: 'right',
        margin: [2, 0, 0, 0]
    },
    footerTable: {
        margin: [23, 0, 23, 0],
        fontSize: 7
    },

    rightFooterPart: {
        alignment: 'right',
        color: '#3D3D3D'
    },
    leftFooterPart: {
        alignment: 'left',
        color: '#6A6A6A'
    },
    viewTTHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'left',
        margin: [12, 9, 0, 9],
        border: 1
    },
    viewTTRows: {
        fontSize: 9,
        alignment: 'left'
    },

    coloredTime: {
        fillColor: '#f5f9fc',
        fontSize: 9,
        alignment: 'center'
    },

    coloredBoldTime: {
        bold: true,
        fillColor: '#ebf2f9'
    }
};

const baseParameters = {

    headerMargins(pageMargins) {
        return [pageMargins[0], pageMargins[1], pageMargins[2], 0];
    },
    footerMargins(pageMargins) {
        return [pageMargins[0], 0, pageMargins[2], 10]
    },

    Landscape: {
        logoPlaceholderSizes: {
            width: 100,
            height: 51
        },
        headerHeight: 51,
        headerBottomMargin: 5,
        pageOrientation: 'landscape',
        pageMargins: [56, 28, 56, 28],
        leaveTextLen: 36,
        itemTextLen: 80,

        noteParameters: {
            fontSize: 8,
            asteriskSize: 6,
            color: '#f58f0a',
            widths: ['2%', '98%'],
            marginLeft: 1
        },

        filterViewParameters: {
            margins: {
                top: 2
            },
            imageMargins: {
                top: 12,
                left: 10
            },
            firstRowMargins: {
                top: 12,
                bottom: 5
            },
            secondRowMargins: {
                bottom: 12
            },
            widths: ['12%', '88%'],
            imageWidth: 9,
            fontSize: 8
        },

        A4: {
            pageSize: 'A4',

            filterViewTextLen: 51,//57

            pdfInfoParameters: {
                withLogo: {
                    widths: ['25%', '75%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        },

        Letter: {
            pageSize: 'Letter',

            filterViewTextLen: 48,//54

            pdfInfoParameters: {
                withLogo: {
                    widths: ['25%', '75%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        }
    },
    Portrait: {
        logoPlaceholderSizes: {
            width: 100,
            height: 44
        },
        headerHeight: 102,
        headerBottomMargin: 5,
        pageOrientation: 'portrait',
        pageMargins: [40, 28, 40, 28],
        leaveTextLen: 24,
        itemTextLen: 40,

        noteParameters: {
            fontSize: 8,
            asteriskSize: 6,
            color: '#f58f0a',
            widths: ['2%', '98%'],
            marginLeft: 3
        },

        filterViewParameters: {
            margins: {
                top: 12
            },
            imageMargins: {
                top: 11,
                left: 12
            },
            firstRowMargins: {
                top: 10,
                bottom: 5
            },
            secondRowMargins: {
                bottom: 9
            },
            widths: ['6%', '94%'],
            imageWidth: 10,
            fontSize: 9
        },

        A4: {
            pageSize: 'A4',

            filterViewTextLen: 102, //108

            pdfInfoParameters: {
                withLogo: {
                    widths: ['22%', '78%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        },
        Letter: {
            pageSize: 'Letter',

            filterViewTextLen: 105,// 111

            pdfInfoParameters: {
                withLogo: {
                    widths: ['22%', '78%']
                },
                withoutLogo: {
                    splitterLen: 533,
                    widths: ['0%', '100%']
                }
            }
        }
    }
};

const baseTabelLayouts = {
    noBordersNoPadding: {
        hLineWidth() { return 0; },
        vLineWidth() { return 0; },
        paddingLeft() { return 0; },
        paddingRight() { return 0; },
        paddingTop() { return 0; },
        paddingBottom() { return 0; }
    },
    simpleBorders: {
        hLineWidth() { return 1; },
        vLineWidth() { return 1; },
        paddingLeft() { return 0; },
        paddingRight() { return 0; },
        paddingTop() { return 0; },
        paddingBottom() { return 0; }
    },
    thinBordersNoPaddingsForFilterView: {
        hLineWidth() { return 0.4; },
        vLineWidth() { return 0.4; },
        paddingLeft() { return 0; },
        paddingRight() { return 0; },
        paddingTop() { return 0; },
        paddingBottom() { return 0; },
        hLineColor() { return '#EFEFEF' },
        vLineColor() { return '#EFEFEF' }
    },
    headerBorderSeparatedRows: {
        hLineWidth() { return 0.4; },
        vLineWidth() { return 0; },
        paddingLeft() { return 5; },
        paddingRight() { return 5; },
        paddingTop() { return 5; },
        paddingBottom() { return 5; },
        hLineColor(i, node) {
            return (i === 0 || i === node.table.body.length) ? '#fbfbfb' : '#f0f0f0';
        },
        vLineColor(i, node) {
            return (i === 0 || i === node.table.widths.length) ? 'red' : 'blue';
        }
    }
};


// WEBPACK FOOTER //
// ./web/js/pdf/BasePDFDefinitionBuilder.js